/* eslint-disable */
import React, { useState, useEffect } from 'react';
import SideBarContainer from 'Containers/SideBarContainer';
import BasicTable from '../../Components/BasicTable';
import Search from '../../Components/Search';
import Title from '../../Components/Title';
import DropDown from '../../Components/DropDown';

import style from './style';

import useDropDown from './Hooks/useDropdown';
import useTranslation from '../../Hooks/useTranslation';
import useComponent from './Hooks/useComponent';
import useJobTitle from './Hooks/useJobTitle';
import useOptions from './Hooks/useOptions';

const { containerJobTitle, searchContainer, findContainer } = style;

export default function JobTitle() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const { jobTitles, setJobTitles } = useJobTitle(setIsLoading);
  const { setSearch, setStatus, filteredJobTitles } = useDropDown(jobTitles);
  const { thereIsComponent } = useComponent({ jobTitles, setJobTitles });
  const editOption = useOptions();
  const titles = [t('JobTitle.Status')];
  const options = [[t('Generic.Active'), t('Generic.Inactive')]];
  const methods = [setStatus];

  return (
    <SideBarContainer>
      <div style={containerJobTitle}>
        <Title title={t('JobTitle.Title')} subtitle={t('JobTitle.SubTitle')} />
        <div style={searchContainer}>
          <div style={{ width: '40%' }}>
            <Search setData={setSearch} placeholder={t('JobTitle.Search')} />
          </div>
          <div style={findContainer} className="flex">
            {titles.map((title, index) => (
              <DropDown key={title + index} title={title} options={options[index]} setData={methods[index]} />
            ))}
          </div>
        </div>

        <BasicTable
          information={filteredJobTitles}
          headers={[t('JobTitle.Name'), t('JobTitle.TotalEmployees'), t('JobTitle.Department'), t('JobTitle.Status')]}
          limit={4}
          thereIsComponent={thereIsComponent}
          configButtonEvents={[null, null]}
          isLoading={isLoading}
        />
      </div>
    </SideBarContainer>
  );
}
